<template>
  <div>
    <p class="login" ><span class="icon-webchat login_icon"></span></p>
  </div>
</template>
<script type="text/ecamscript-6">
import {login} from "../../common/js/common.js"
  export default {
    name:"login",
    data(){
      return {

      }
    },
    methods:{

      // login() {
      //   let url = "gzh/sqw/getUserInfo.php"
      //   this.$ajax.autoService
      //   .login(url).then((res) => {
      //     //console.log(res)
      //      res.data = {
      //         appid: "wx64c594fbcfb9feb8",
      //         avatarUrl: "http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eokJTRwsdzAh3Nqgee3Yj97l9Dmcqv7IrbznMiazZ5WwzTWiaCEFxW9ibyXQYvyvg4LQw6OFkQa4nT3A/132",
      //         city: "长沙",
      //         country: "中国",
      //         gender: "2",
      //         nikeName: "土匪妹妹",
      //         openId: "oTLarw7dMe7cPjnuMggSkIkp0RWg",
      //         province: "湖南",
      //         totalScore: "0",
      //         usedScore: "0",
      //         userCreateTime: "2018-08-03 11:05:11",
      //      }
      //      localStorage.setItem('userInfo', JSON.stringify(res.data));
      //      this.$store.dispatch('getUserInfo')
      //      this.$store.dispatch('getScoreUserInfo')
      //   },(res)=>{
      //     console.log("error")
      //   }
      // )
      // }
    }
  }
</script>
<style lang="stylus">
  .login
    padding:20px 20px
    display:block
    text-align:center
    position:fixed;
    bottom:200px;
    right:5px;
    background:rgba(255,255,255,0.8);
    border-radius:50%
    .login_icon
      font-size:60px;
      color:#333

</style>



// WEBPACK FOOTER //
// src/components/login/login.vue